import React, { Component } from "react";
import { connect } from "react-redux";
import { Avatar, Popover } from "antd";
import { userSignOut } from "appRedux/actions/Auth";
import avatar from "../../landing/pic/tempProfilePic.png";

class UserProfile extends Component {
    render() {
        return (
            <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
                <Avatar
                    src={avatar}
                    className="gx-size-40 gx-pointer gx-ml-3"
                    alt=""
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <p className="gx-avatar-name">خوش امدید</p>
                    <span className="gx-avatar-name">
                        {localStorage.getItem("phone")}
                    </span>
                </div>
            </div>
        );
    }
}

export default connect(null, { userSignOut })(UserProfile);
